<template>
  <div class="q-pa-xs">
    <div
      class="text-subtitle1 text-weight-bold q-pl-sm q-py-xs"
      :class="$q.dark.mode === true ? 'text-grey-2' : 'text-primary'"
    >
      Announcement
    </div>
    <div v-if="slicedData.length">
      <q-separator />
      <q-list v-for="item in slicedData" :key="item.id">
        <div class="cursor-pointer" @click="onClickItem(item)">
          <q-item class="q-pl-xs">
            <q-item-section side top>
              <q-item-label>
                <div class="text-caption q-ml-none">
                  <q-icon
                    name="star"
                    size="xs"
                    :color="
                      this.$q.dark.mode === true ? 'text-black' : 'primary '
                    "
                  />

                  {{ convertDate(item.created_at.split("T")[0]) }}
                </div>
              </q-item-label>
            </q-item-section>

            <q-item-section
              :class="item.id == 1575 ? ' text-bold text-green-9' : ''"
            >
              <q-item-label class="text-caption ellipsis">
                <span class="text-bold">
                  <div>
                    {{ item.title }}
                  </div>
                </span>
              </q-item-label>

              <q-item-label
                caption
                lines="2"
                class="ellipsi"
                :class="item.id == 1575 ? ' text-bold text-green-9' : ''"
                >{{ item.message }}</q-item-label
              >
            </q-item-section>
          </q-item>
        </div>
      </q-list>
      <q-separator class="q-my-xs" />

      <div class="text-center">
        <div class="q-pa-x flex flex-center">
          <q-pagination
            v-model="currentPage"
            :max="maxPage"
            direction-links
            flat
            color="grey"
            active-color="blue-5"
            :max-pages="1"
            boundary-numbers
          />

          <q-btn
            v-if="pageSize !== 7"
            dense
            flat
            no-caps
            color="blue-5"
            @click="showAllData = !showAllData"
          >
            {{ showAllData ? "Show Less" : "Show All" }}
          </q-btn>

          <q-btn
            v-if="pageSize === 7"
            dense
            flat
            no-caps
            color="primary"
            icon-right="arrow_right"
            @click="this.$router.push({ path: '/announcement' })"
            >View Details
          </q-btn>
        </div>
      </div>
    </div>
    <div v-else>No Data Found</div>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import useAnnouncement from "src/use/announcement";
import moment from "moment";

import { useRouter } from "vue-router";

export default {
  name: "AnnouncementDashboard",
  props: {
    pageSize: {
      type: Number,
      default() {
        return window.innerWidth < 576 ? 7 : 7;
      },
    },
  },
  components: {},
  setup(props) {
    const router = useRouter();
    const { getDashboardAnnouncement, getAllAnnouncement } = useAnnouncement();
    const announcementList = ref([]);
    const currentItem = ref({});
    const currentPage = ref(1);
    const showAllData = ref(false);

    getAllAnnouncement().then((res) => {
      announcementList.value = res.data;
      // let dashainOffer = res.data.find((i) => i.id == 1575);
      // announcementList.value = res.data.filter((i) => i.id != 1575);
      // announcementList.value = [dashainOffer, ...announcementList.value];
    });

    const slicedData = computed(() => {
      if (showAllData.value) {
        return announcementList.value;
      } else {
        const startIndex = (currentPage.value - 1) * props.pageSize;
        const endIndex = startIndex + props.pageSize;
        return announcementList.value.slice(startIndex, endIndex);
      }
    });

    const maxPage = computed(() => {
      return Math.ceil(
        showAllData.value
          ? announcementList.value.length
          : announcementList.value.length / props.pageSize
      );
    });

    function onClickItem(item) {
      const url = item.click_url;
      if (url) {
        if (url.startsWith(process.env.BASE_URL)) {
          if (url.includes("stock-profile")) {
            router.push({
              // path: url.split("#")[1],
              path: url.includes("#")
                ? url.split("#")[1]
                : url.split(".com")[1],
              query: {
                symbol: url.split("?symbol=")[1].split("&")[0],
                signal: url.split("&signal=")[1],
              },
            });
          } else {
            router.push({
              // path: url.split("#")[1],
              path: url.includes("#")
                ? url.split("#")[1]
                : url.split(".com")[1],
            });
          }
        } else {
          window.open(url);
        }
      }

      // if (item.click_url.startsWith(process.env.BASE_URL)) {
      //   window.open(item.click_url, "_self");
      // } else {
      //   window.open(item.click_url, "_self");
      // }
      // dialogAnnouncement.value = false;
    }

    const convertDate = (date) => {
      const newDate = moment(date).format("MMM-DD");
      return newDate;
    };

    return {
      announcementList,
      currentItem,

      onClickItem,

      slicedData,

      currentPage,
      maxPage,

      showAllData,
      convertDate,
    };
  },
};
</script>
